import React,{useEffect,useState} from "react";
import api from "../services/api";

export default function TrainerForm({trainerId,setPage}) {
  const editing=Boolean(trainerId);
  const [form,setForm]=useState({
    first_name:"",last_name:"",email:"",password:"",status:"active",
    product_access:{lms:false,live:true}
  });

  useEffect(()=>{
    if(!editing) return;
    api.get("/trainers").then(res=>{
      const t=(res.data.data||[]).find(x=>x.id===trainerId);
      if(t) setForm({
        first_name:t.first_name||"",last_name:t.last_name||"",email:t.email||"",
        password:"",status:t.status||"active",
        product_access:t.products||{lms:false,live:true}
      });
    }).catch(console.error);
  },[editing,trainerId]);

  const set=(key,value)=>setForm(prev=>({...prev,[key]:value}));
  const setProduct=(key,value)=>setForm(prev=>({
    ...prev,product_access:{...prev.product_access,[key]:value}
  }));

  async function save(){
    if(!form.first_name.trim()||!form.email.trim()||(!editing&&!form.password)){
      return alert("First name, email and password are required");
    }
    if(!form.product_access.lms && !form.product_access.live){
      return alert("Select LMS, LIVE, or both");
    }
    try {
      if(editing) await api.put(`/trainers/${trainerId}`,form);
      else await api.post("/trainers",form);
      alert(editing?"Trainer updated successfully":"Trainer created successfully");
      setPage({page:"trainers"});
    } catch(err) {
      alert(err?.response?.data?.message||"Unable to save trainer");
    }
  }

  return <div style={{padding:"30px",maxWidth:"900px"}}>
    <h2>{editing?"Edit Trainer":"Create Trainer"}</h2>
    <div style={card}>
      <input style={input} placeholder="First Name" value={form.first_name} onChange={e=>set("first_name",e.target.value)}/>
      <input style={input} placeholder="Last Name" value={form.last_name} onChange={e=>set("last_name",e.target.value)}/>
      <input style={input} placeholder="Email" value={form.email} onChange={e=>set("email",e.target.value)}/>
      <input style={input} type="password" placeholder={editing?"Change Password (optional)":"Password"} value={form.password} onChange={e=>set("password",e.target.value)}/>
      <select style={input} value={form.status} onChange={e=>set("status",e.target.value)}>
        <option value="active">Active</option><option value="inactive">Inactive</option>
      </select>
    </div>
    <div style={card}>
      <h3>Product Access</h3>
      <p style={{color:"#666"}}>Choose LMS, LIVE, or both.</p>
      <div style={{display:"flex",gap:"30px"}}>
        <label><input type="checkbox" checked={form.product_access.lms} onChange={e=>setProduct("lms",e.target.checked)}/> MaAz LMS</label>
        <label><input type="checkbox" checked={form.product_access.live} onChange={e=>setProduct("live",e.target.checked)}/> MaAz Live</label>
      </div>
    </div>
    <button style={primaryBtn} onClick={save}>{editing?"Update Trainer":"Create Trainer"}</button>
    <button style={cancelBtn} onClick={()=>setPage({page:"trainers"})}>Cancel</button>
  </div>;
}
const card={background:"#fff",padding:"25px",borderRadius:"8px",boxShadow:"0 2px 10px rgba(0,0,0,.08)",marginBottom:"25px"};
const input={width:"100%",padding:"10px",marginBottom:"12px",border:"1px solid #ddd",borderRadius:"6px"};
const primaryBtn={background:"#2c3e50",color:"#fff",padding:"10px 18px",border:"none",borderRadius:"6px",marginRight:"10px",cursor:"pointer"};
const cancelBtn={padding:"10px 18px",borderRadius:"6px",border:"1px solid #ccc",cursor:"pointer"};
